import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  selectProviderDetails,
  selectProviderDetailsPending,
  selectProviderGWDetailsPending,
} from '../../../../redux/appointmentForm/selectors';
import {
  momentFormat,
  getISOString,
  nowLocalMoment,
} from '../../../../utils/appointments/dateFilter';

export const nowDate = nowLocalMoment.toDate();
const format = momentFormat('MMMM, D');

export function useProviderCalendar(onDateChange) {
  const availableLocationsByProvider = useSelector(selectProviderDetails) || [];
  const loadingProviderDetailsGW = useSelector(selectProviderGWDetailsPending);
  const loadingProviderDetails = useSelector(selectProviderDetailsPending);
  const [startDate, setStartDate] = useState(nowDate);
  const displayableTime = useMemo(() => format(startDate, true), [startDate]);
  const loading = loadingProviderDetailsGW || loadingProviderDetails;

  useEffect(() => {
    onDateChange(getISOString(startDate));
  }, []);

  const handleDateChange = date => {
    if (loading) return;
    setStartDate(date);
    onDateChange(getISOString(date));
  };

  return {
    loading,
    startDate,
    displayableTime,
    handleDateChange,
    availableLocationsByProvider,
    formatCurrentDate: getISOString(startDate),
  };
}



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviderDetails/ProviderCalendar/useProviderCalendar.js